import React, { useState } from 'react';
import {
  ChakraProvider,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  HStack,
  Icon,
  Box,
  useColorModeValue
} from '@chakra-ui/react';
import { FaInfoCircle, FaBuilding, FaFileAlt, FaClipboardList, FaEdit, FaTrashAlt, FaTimes, FaFolder } from 'react-icons/fa';
import DadosBasicos from './DadosBasicos/DadosBasicos.js';
import ClienteForm from '../ClienteForm.js';
import DadosCNPJ from './DadosCNPJ/DadosCNPJ.js';
import DadosComplementares from './DadosComplementares/DadosComplementares.js';
import Registros from './Registros/Registros.js';
import Documentos from './Documentos/Documentos.js';

const ClienteModal = ({ 
  isOpen, 
  onClose,  
  cliente, 
  showForm, 
  isEditing, 
  onEdit, 
  onDelete, 
  onFormSubmit,
  onCancel
}) => {
  // State for active tab
  const [tabIndex, setTabIndex] = useState(0);
  
  // Get user role from localStorage
  const userRole = localStorage.getItem('userRole') || 'user';
  const userType = localStorage.getItem('userType') || '';
  const isMaster = userType === 'master';
  
  // Theme colors
  const bgColor = useColorModeValue('white', 'gray.800');
  const headerBg = useColorModeValue('#3E5F56', '#2D4A42');
  
  return (
    <ChakraProvider>
      <Modal 
        isOpen={isOpen} 
        onClose={onClose}
        size="6xl"
        isCentered
        scrollBehavior="inside"
      >
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent maxH="85vh" bg={bgColor}>
          <ModalHeader bg={headerBg} color="white">
            {showForm 
              ? (isEditing ? 'Editar Cliente' : 'Novo Cliente') 
              : 'Detalhes do Cliente'}
          </ModalHeader>
          <ModalCloseButton color="white" />
          
          <ModalBody p={0}>
            {showForm ? (
              <Box p={6}>
                <ClienteForm 
                  cliente={isEditing ? cliente : null}
                  onSubmit={onFormSubmit}
                  onCancel={onCancel}
                />
              </Box>
            ) : cliente ? (
              <Tabs index={tabIndex} onChange={setTabIndex} variant="enclosed" colorScheme="green">
                <TabList borderBottomWidth="2px">
                  <Tab _selected={{ color: headerBg, borderColor: headerBg, bg: 'white' }}>
                    <Icon as={FaInfoCircle} mr={2} />
                    Dados Básicos
                  </Tab>
                  <Tab _selected={{ color: headerBg, borderColor: headerBg, bg: 'white' }}>
                    <Icon as={FaBuilding} mr={2} />
                    Dados CNPJ
                  </Tab>
                  <Tab _selected={{ color: headerBg, borderColor: headerBg, bg: 'white' }}>
                    <Icon as={FaFileAlt} mr={2} />
                    Dados Complementares
                  </Tab>
                  <Tab _selected={{ color: headerBg, borderColor: headerBg, bg: 'white' }}>
                    <Icon as={FaClipboardList} mr={2} />
                    Registros
                  </Tab>
                  <Tab _selected={{ color: headerBg, borderColor: headerBg, bg: 'white' }}>
                    <Icon as={FaFolder} mr={2} />
                    Documentos
                  </Tab>
                </TabList>
                
                <TabPanels>
                  <TabPanel p={0}>
                    <DadosBasicos 
                      cliente={cliente} 
                      onEdit={onEdit}
                      onDelete={onDelete}
                    />
                  </TabPanel>
                  
                  <TabPanel p={0}>
                    <DadosCNPJ clienteId={cliente._id} />
                  </TabPanel>
                  
                  <TabPanel p={0}>
                    <DadosComplementares clienteId={cliente._id} />
                  </TabPanel>
                  
                  <TabPanel p={0}>
                    <Registros clienteId={cliente._id} />
                  </TabPanel>
                  
                  <TabPanel p={0}>
                    <Documentos clienteId={cliente._id} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            ) : (
              <Box p={10} textAlign="center" color="gray.500">
                Nenhum cliente selecionado
              </Box>
            )}
          </ModalBody>
          
          {!showForm && cliente && (
            <ModalFooter bg="gray.50" borderTopWidth="1px">
              <HStack spacing={3}>
                <Button
                  leftIcon={<FaEdit />}
                  variant="outline"
                  colorScheme="green"
                  onClick={onEdit}
                >
                  Editar
                </Button>
                
                {isMaster && (
                  <Button
                    leftIcon={<FaTrashAlt />}
                    colorScheme="red"
                    onClick={onDelete}
                  >
                    Excluir
                  </Button>
                )}
                
                <Button
                  leftIcon={<FaTimes />}
                  variant="solid"
                  bg={headerBg}
                  color="white"
                  _hover={{ bg: '#2D4A42' }}
                  onClick={onClose}
                >
                  Fechar
                </Button>
              </HStack>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
};

export default ClienteModal;